<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_addressType') || '地址类型'"
            prop="addressType"
          >
            <dict-select
              v-model="formData.addressType"
              :body="addressTypeParams"
              url="/sys/common/dict/system"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              style="width:100%"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item :label="$l('form_label_linkPoRule') || 'PO规则'">
            <el-input
              v-model="formData.linkPoRule"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_addressName') || '地址中文名称'">
            <el-input
              v-model="formData.addressName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="300"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_addressEnName') || '地址英文名称'"
            prop="addressEnName"
          >
            <el-input
              v-model="formData.addressEnName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="300"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_address') || '中文地址'">
            <el-input
              v-model="formData.address"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              clearable
              maxlength="500"
              show-word-limit
              :autosize="{ minRows: 2, maxRows: 4 }"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_addressEn') || '英文地址'">
            <el-input
              v-model="formData.addressEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              clearable
              maxlength="500"
              show-word-limit
              :autosize="{ minRows: 2, maxRows: 4 }"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCustomerCode: { type: String, default: '' },
    shipmentCustomerAddressCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      addressTypeParams: { dictType: 'customerAddressType' },
      rules: {
        addressType: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        addressEnName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.shipmentCustomerAddressCode) return
      this.$api
        .shipmentCustomerAddressDetailApi({
          shipmentCustomerAddressCode: this.shipmentCustomerAddressCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      const res = await this.$api
        .shipmentCustomerAddressSaveApi({
          ...this.formData,
          shipmentCustomerCode: this.shipmentCustomerCode,
        })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status != 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
